<script setup lang="ts">
import type { ButtonColor, ButtonVariant } from "~~/models/buttons";
import type { ButtonRecord } from "~~/server/graphql/datocms/generated";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "~~/models/buttons";

interface Props {
  data: ButtonRecord;
  size?: "sm" | "md" | "xl";
}

const props = withDefaults(defineProps<Props>(), {
  size: "xl",
});

const variant = computed<ButtonVariant>(() => {
  const v = props.data.optStyle?.variant;
  return BUTTON_VARIANTS.includes(v as ButtonVariant) ? (v as ButtonVariant) : "solid";
});

const color = computed<ButtonColor>(() => {
  const c = props.data.optStyle?.color;
  return BUTTON_COLORS.includes(c as ButtonColor) ? (c as ButtonColor) : "primary";
});
</script>

<template>
  <UButton
    :variant="variant"
    :color="color"
    :size="size"
    :ui="{ base: 'leading-7' }"
    :to="data.url"
    :target="getTarget(data.url)"
    class="structured-button"
  >
    {{ data.label }}
  </UButton>
</template>

<style scoped>

</style>
